<label
  class="flex flex-row items-center justify-center switcher-container gap-[0.4rem]"
  [class.opacity0p64]="disabled"
  [class.no-propagation]="noPropagation$$() || disabled">
  @if (leftText$$()) {
    <span [class.disabled]="value">{{leftText$$()}}</span>
  }
  <div class="switch">
    <input
      type="checkbox"
      [checked]="value"
      [disabled]="disabled"
      (change)="onCheckedChange($event)">
      <span
        data-qa="switch-slider"
        class="slider round"
        [ngClass]="value ? 'enabled' : 'disabled'"
        [class.standard]="!leftText$$()">
      </span>
    </div>
    @if (rightText$$()) {
      <span [class.disabled]="!value">{{rightText$$()}}</span>
    }
  </label>
